(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioDetailController', SSFuncionarioDetailController);

    SSFuncionarioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSFuncionario', 'SSPersona'];

    function SSFuncionarioDetailController($scope, $rootScope, $stateParams, previousState, entity, SSFuncionario, SSPersona) {
        var vm = this;

        vm.sSFuncionario = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSFuncionarioUpdate', function(event, result) {
            vm.sSFuncionario = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
